import React, { useState } from 'react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { errorFormatter } from '../utils/errorFunctions'

const reload = () => window.location.reload()

const SCRAPE_XML = gql`
  mutation xmlToSbJsonFgdcxmlQuery($input: xmlToSbJsonInput!) {
    xmlToSbJson(input: $input) {
      item
    }
  }
`


export default function ScrapeXmlModalFgdc(props) {

  const [isLoading, setIsLoading] = useState(false)
  const [isComplete, setIsComplete] = useState(false)
  const [showClose, setShowClose] = useState(false)

  const handleClose = () => {
    props.onHide()
    reload()
  }

  let title = ''
  const dataAction = props.action
  if (dataAction === 'fgdc'){
    title = 'Scrape fgdc xml'
  } else if (dataAction === 'iso'){
    title = 'Scrape iso xml'
  } else if (dataAction === 'mdJson'){
    title = 'Scrape md json'
  } 

  const [scrape_xml] = useMutation(
    SCRAPE_XML,
    {
      variables: {
        input: {
          itemId: props.itemId,
          fileName: props.row.name,
          pathOnDisk: props.row.pathOnDisk,
          fileType: props.row.contentType,
          bucket: props.row.bucket,
          action: 'update_item'
        }
      }
    }
  )

  return (
    <Modal {...props} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form
          onSubmit= {e => {
            setIsLoading(true)
            e.preventDefault()
            scrape_xml().then(              
              result => {
                reload()
              },
              error => {
                props.onHide()
                setIsLoading(false)
              }
            )
          }}
        >
          <h3>You are about to {title} xml: {props.row.name}</h3>
          <Modal.Footer>
            <Button variant='secondary' onClick={props.onHide}>Close</Button>
            {isComplete ? '' : <Button variant="primary" type="submit">{isLoading ? <span ><FontAwesomeIcon icon={faSpinner} pulse /></span> : ''}&nbsp;{title} </Button>}
            </Modal.Footer>
        </form>
      </Modal.Body>
    </Modal>
  )
}

ScrapeXmlModalFgdc.propTypes = {
  row: PropTypes.shape({
    cuid: PropTypes.string,
    bucket: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    pathOnDisk: PropTypes.string,
    contentType: PropTypes.string,
    scrapeMetadata: PropTypes.any,
    status: PropTypes.shape({
      scanPassed: PropTypes.bool
    })
  }),
  itemId: PropTypes.string,
  onHide: PropTypes.func,
  action: PropTypes.string,
}
